var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpleBoothLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.23 41.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212020;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.47,16.94,9.08,15a5.69,5.69,0,0,0,3.69,1.5c1.11,0,1.78-.44,1.78-1.17v0c0-.69-.42-1-2.49-1.57C9.57,13.11,8,12.42,8,10v0c0-2.24,1.8-3.72,4.32-3.72a7.13,7.13,0,0,1,4.59,1.57L15.47,9.83a5.81,5.81,0,0,0-3.22-1.22c-1,0-1.58.48-1.58,1.08v0c0,.81.53,1.08,2.66,1.63,2.51.65,3.92,1.55,3.92,3.7v0c0,2.45-1.87,3.83-4.54,3.83A7.88,7.88,0,0,1,7.47,16.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,6.39h2.72V18.74H24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.31,6.39h2.93l3.25,5.22,3.25-5.22h2.93V18.74H43V10.68L39.49,16h-.07L36,10.73v8H33.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.51,6.39h5.05c2.95,0,4.73,1.74,4.73,4.27v0c0,2.86-2.22,4.34-5,4.34H55.23v3.71H52.51Zm4.87,6.23a1.92,1.92,0,0,0,2.16-1.87v0c0-1.22-.85-1.87-2.21-1.87h-2.1v3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.48,6.39H70.2v9.88h6.16v2.47H67.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.35,6.39h9.32V8.8H86.05v2.51h5.82v2.42H86.05v2.59h6.7v2.42h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.65,22.37h5.73a4.42,4.42,0,0,1,3.23,1.09,2.82,2.82,0,0,1,.85,2.1v0a2.87,2.87,0,0,1-1.62,2.66,3,3,0,0,1,2.31,3v0c0,2.26-1.84,3.39-4.62,3.39H7.65ZM14.76,26c0-.81-.63-1.27-1.78-1.27H10.3v2.61h2.5c1.2,0,2-.39,2-1.31Zm-1.32,3.6H10.3v2.72h3.23c1.2,0,1.92-.43,1.92-1.34v0C15.45,30.13,14.83,29.62,13.44,29.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.79,28.58v0a6.39,6.39,0,0,1,6.58-6.39,6.34,6.34,0,0,1,6.55,6.36v0a6.39,6.39,0,0,1-6.59,6.39A6.32,6.32,0,0,1,24.79,28.58Zm10.29,0v0a3.76,3.76,0,0,0-3.75-3.88,3.7,3.7,0,0,0-3.7,3.85v0a3.76,3.76,0,0,0,3.74,3.89A3.7,3.7,0,0,0,35.08,28.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.73,28.58v0a6.57,6.57,0,0,1,13.13,0v0a6.57,6.57,0,0,1-13.13,0Zm10.29,0v0a3.75,3.75,0,0,0-3.74-3.88,3.7,3.7,0,0,0-3.71,3.85v0a3.76,3.76,0,0,0,3.74,3.89A3.7,3.7,0,0,0,55,28.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.92,24.87H64.16v-2.5H74.4v2.5H70.64v9.85H67.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.13,22.37h2.72v4.89h5V22.37h2.72V34.72H89.86v-5h-5v5H82.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0V41.22l100.23.24V0ZM98.11,39h-96V2.11h96Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleBoothLogoBlack);
export default __webpack_public_path__ + "static/media/simple-booth-logo-black.d63aed6c951832a22093dd2a187604cf.svg";
export { ForwardRef as ReactComponent };